module.exports = __webpack_public_path__ + "img/section3Logo2.cb78c8bc.webp";